import React, { memo } from 'react';

import { Stack, Typography } from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';

import {
  stepSummaryContainerStyles,
  stepSummaryLabelStyles,
  stepSummaryTextStyles,
} from './StepSummaryContent.styles';

const StepSummaryContent = ({ contentProps }) => {
  const { label, summary } = contentProps;
  const hasLabel = _.isString(label) && label.length > 0;

  return (
    <Stack sx={stepSummaryContainerStyles}>
      {hasLabel && (
        <Typography color="text.secondary" sx={stepSummaryLabelStyles} variant="medium12">
          {label}
        </Typography>
      )}
      <Typography sx={stepSummaryTextStyles} variant="regular14">
        {summary}
      </Typography>
    </Stack>
  );
};

StepSummaryContent.propTypes = {
  contentProps: PropTypes.shape({
    summary: PropTypes.string.isRequired,
    label: PropTypes.string,
  }).isRequired,
};

export default memo(StepSummaryContent);
